import { FieldExtensionComponentProps } from "@backstage/plugin-scaffolder-react";
import { type Option, Select } from "@backstage/ui";

import { useGcpBusinessUnits } from "../hooks";

/**
 * Scaffolder field extension that renders a select input populated with
 * GCP business unit names fetched from GitHub via `githubApiRef`.
 *
 * Displays a loading placeholder while data is being fetched.
 *
 * @param props - Standard scaffolder field extension component props.
 */
export const GcpBusinessUnitsSelectField = ({
    onChange,
    rawErrors,
    required,
    formData,
}: FieldExtensionComponentProps<string>) => {
    const { businessUnits, loading } = useGcpBusinessUnits();
    if (loading) {
        return <div>Loading Business Units...</div>;
    }
    const options: Option[] = businessUnits.map(businessUnit => ({
        value: businessUnit,
        label: businessUnit,
    }));
    return (
        <Select
            label="Business Unit"
            isRequired={required}
            isInvalid={rawErrors?.length > 0 && !formData}
            options={options}
            value={formData}
            onChange={key => onChange(String(key))}
        />
    );
};
